module.exports = __webpack_public_path__ + "static/media/Man4.a2a8b29d.png";